import React, { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";

const DEFAULT_DEBOUNCING_VALUE = 50;
const DebouncingInputsContext = createContext(0);

const DebouncingInputsProvider = ({ children, value = DEFAULT_DEBOUNCING_VALUE, disabled }) => {
  const [debouncingValue] = useState(disabled ? 0 : value);

  return <DebouncingInputsContext.Provider value={{ debouncingValue }}>{children}</DebouncingInputsContext.Provider>;
};

DebouncingInputsProvider.propTypes = {
  /*
   * Indica el valor del debouncing para este formulario
   */
  value: PropTypes.number,
  /*
   * Deshabilita el debouncing
   */
  disabled: PropTypes.bool,
};

const useDebouncingInputsContext = () => {
  return useContext(DebouncingInputsContext);
};

export { DebouncingInputsProvider, useDebouncingInputsContext };
